import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { eventsApi } from "../services/api";
import EventCard from "../components/EventCard";

const CATEGORIES = ["All", "Cruises", "Resorts", "Short Notice", "Meetups"];

function Home() {
  const [events, setEvents] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    eventsApi.list({ public: "true" })
      .then(data => setEvents(Array.isArray(data) ? data.filter(e => e.status !== "archived") : []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, []);

  const CATEGORY_MAP = { "Cruises": "cruise", "Resorts": "resort", "Short Notice": "short-notice", "Meetups": "meetup" };

  const filtered = activeCategory === "All"
    ? events
    : events.filter(e => e.eventType === CATEGORY_MAP[activeCategory]);

  return (
    <>
      <section className="hero">
        <div className="container">
          <h1>Get <span>Comp'd</span> on the<br />Finest Experiences</h1>
          <p>
            Casino cruises, luxury resorts, and exclusive events.
            Submit your play history and let us match you with premium comp'd offers.
          </p>
          <div className="hero-actions">
            <Link to="/events" className="btn btn-primary">Browse Events</Link>
            <Link to="/how-it-works" className="btn btn-outline-white">How It Works</Link>
          </div>
          <div className="categories">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                className={`category-pill ${activeCategory === cat ? "active" : ""}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>How It Works</h2>
            <p>Three simple steps to unlock comp'd casino experiences</p>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Browse Events</h3>
              <p>Explore curated comp'd cruises, resort stays, meetups, and flash deals from top casino hosts.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Submit Your Info</h3>
              <p>Share your play history, loyalty tier, and any current casino offers to verify qualification.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Get Comp'd</h3>
              <p>Receive confirmation within 24-48 hours and enjoy comp'd rooms, meals, and entertainment.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="events-section" style={{ background: "var(--white)", padding: "70px 0" }}>
        <div className="container">
          <h2>Featured Events</h2>
          <p style={{ color: "var(--text-secondary)", marginBottom: "32px" }}>Handpicked comp'd experiences from our host partners</p>
          {loading ? (
            <p style={{ color: "var(--text-light)" }}>Loading events...</p>
          ) : filtered.length === 0 ? (
            <p style={{ color: "var(--text-light)", padding: "40px 0", textAlign: "center" }}>No events available yet. Check back soon.</p>
          ) : (
            <div className="events-grid">
              {filtered.map(event => (
                <EventCard key={event.eventId} event={event} />
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

function getSampleEvents() {
  return [
    {
      eventId: "sample-1", title: "Caribbean Casino Cruise",
      description: "7-night luxury cruise with complimentary casino play, fine dining, and entertainment. Ports include Cozumel, Grand Cayman, and Jamaica.",
      eventType: "cruise", location: "Miami, FL", startDate: "2026-06-15",
      imageUrl: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=600",
      images: [
        { url: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=600", caption: "Cruise ship" },
        { url: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600", caption: "Casino floor" },
        { url: "https://images.unsplash.com/photo-1540541338287-41700207dee6?w=600", caption: "Pool deck" },
      ],
      links: [{ url: "#", label: "Full Itinerary" }, { url: "#", label: "FAQ" }],
      qualificationCriteria: "$500+ average daily play",
    },
    {
      eventId: "sample-2", title: "Vegas VIP Resort Weekend",
      description: "All-inclusive weekend at a premier Las Vegas resort. Comp'd room, meals, show tickets, and tournament entry.",
      eventType: "resort", location: "Las Vegas, NV", startDate: "2026-07-10",
      imageUrl: "https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d?w=600",
      images: [
        { url: "https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d?w=600", caption: "Las Vegas" },
        { url: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=600", caption: "Suite" },
      ],
      links: [{ url: "#", label: "Resort Details" }],
      qualificationCriteria: "$300+ average daily play",
    },
    {
      eventId: "sample-3", title: "Atlantic City Flash Deal",
      description: "Last-minute comp'd stay at Borgata. 2 nights, meals, and $200 free play included.",
      eventType: "short-notice", location: "Atlantic City, NJ", startDate: "2026-05-01",
      imageUrl: "", images: [], links: [],
      qualificationCriteria: "Any active player card",
    },
    {
      eventId: "sample-4", title: "High Roller Meetup — Biloxi",
      description: "Exclusive networking event for casino enthusiasts. Meet hosts, learn about upcoming offers, and enjoy a comp'd dinner.",
      eventType: "meetup", location: "Biloxi, MS", startDate: "2026-08-20",
      imageUrl: "https://images.unsplash.com/photo-1511882150382-421056c89033?w=600",
      images: [{ url: "https://images.unsplash.com/photo-1511882150382-421056c89033?w=600", caption: "Casino night" }],
      links: [],
      qualificationCriteria: "Invitation or referral",
    },
  ];
}

export default Home;
